import { createServerFn } from "@tanstack/react-start";

export type TicketsSettings = {
  enabled: boolean;
  url: string | null;
};

/**
 * Public tickets settings. Reads two site_settings keys:
 *  - tickets_enabled: boolean
 *  - tickets_url: string (external ticket shop URL)
 * Defaults: disabled, no URL.
 */
export const getTicketsSettings = createServerFn({ method: "GET" }).handler(
  async (): Promise<TicketsSettings> => {
    const { cached } = await import("@/lib/server-cache.server");
    return cached("tickets", 120_000, async () => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data } = await supabaseAdmin
      .from("site_settings")
      .select("key,value")
      .in("key", ["tickets_enabled", "tickets_url"]);

    let enabled = false;
    let url: string | null = null;
    for (const row of data ?? []) {
      if (row.key === "tickets_enabled") {
        enabled = row.value === true || row.value === "true";
      } else if (row.key === "tickets_url") {
        const v = typeof row.value === "string" ? row.value.trim() : "";
        url = v.length > 0 ? v : null;
      }
    }
    return { enabled, url };
    });
  },
);